module.exports = __webpack_public_path__ + "static/media/tutorial-4.430e90c6.png";